import { Pagination } from "@mui/material";
import { PaginationStore } from "@root/stores/paginationStore";
import { Event } from "@root/utils/entities";
import { observer } from "mobx-react-lite";
import { Box } from "@mui/material";

interface EventPaginationProps {
    events: Event[];
    store: PaginationStore;
    onChange: (newPage: number) => void;
}

export const EventPagination = observer(({ events, store, onChange }: EventPaginationProps) => {
  // Show pagination if there are events and more than 0 pages
  if (!events || events.length === 0 || store.pageCount <= 0) return null;
  
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mt: 3,
        mb: 2,
        width: "100%",
      }}
    >
      <Pagination
        count={store.pageCount}
        page={store.page + 1}
        boundaryCount={1}
        siblingCount={1}
        showFirstButton
        showLastButton
        onChange={async (_, page) => {
          store.setPage(page - 1);
          onChange(page - 1);
        }}
        sx={{ 
          display: "flex", 
          justifyContent: "center",
          alignItems: "center",
          "& .MuiPagination-ul": {
            justifyContent: "center",
            gap: "4px",
          },
          "& .MuiPaginationItem-root": {
            borderRadius: "50%",
            minWidth: "36px",
            width: "36px",
            height: "36px",
            margin: 0,
            fontSize: "0.875rem",
            fontWeight: 500,
            color: "#666",
            border: "1px solid #e0e0e0",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "#f5f5f5",
              borderColor: "#e0e0e0",
            },
            "&.Mui-disabled": {
              opacity: 0.5,
            },
          },
          "& .MuiPaginationItem-page": {
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          },
          "& .MuiPaginationItem-page.Mui-selected": {
            backgroundColor: "#ff0000",
            color: "white",
            borderColor: "#ff0000",
            "&:hover": {
              backgroundColor: "#ff0000",
              borderColor: "#ff0000",
            },
          },
          "& .MuiPaginationItem-previousNext": {
            border: "1px solid #e0e0e0",
            "&:hover": {
              backgroundColor: "#f5f5f5",
              borderColor: "#e0e0e0",
            },
          },
          "& .MuiPaginationItem-firstLast": {
            border: "1px solid #e0e0e0",
            "&:hover": {
              backgroundColor: "#f5f5f5",
              borderColor: "#e0e0e0",
            },
          },
          "& .MuiPaginationItem-ellipsis": {
            color: "#666",
            border: "none",
            "&:hover": {
              backgroundColor: "transparent",
            },
          },
        }}
      />
    </Box>
  );
});
